// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { ContextStore } from 'bernie-core';

// mobx
import { Legal } from 'src/models';
import { LegalStore } from 'stores';

// shared-ui
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkSubheading, UitkText } from 'uitk-react-text';
import { UitkLink } from 'uitk-react-link';

export interface CookiePolicyProps {
  context?: ContextStore;
  legal?: LegalStore;
}

export interface CookiePolicyState {
  legal?: Legal;
}

@inject('context', 'legal')
export class CookiePolicy extends React.Component<CookiePolicyProps, CookiePolicyState> {
  constructor(props) {
    super(props);

    const siteId = this.props.context.site.id;
    this.state = {
      legal: this.props.legal.getConfig(siteId),
    };
  }

  public render() {
    const { address, email } = this.state.legal;

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <main>
          <UitkSubheading>Last updated 2nd June 2021</UitkSubheading>
          <UitkHeading tag="h2" size={3}>
            Expedia Group Cookie Policy
          </UitkHeading>
          <UitkText spacing="six">
            ‘People Shaped Travel’ is our motto so we work hard to listen to our partners and in return to deliver a
            smart and engaging website that reflects their needs. One of the ways in which we do this, is through the
            use of cookies.
          </UitkText>
          <UitkText spacing="six">
            Not sure what cookies are or what they do? Pay close attention; this page will tell you everything you need
            to know about cookies, as well as teach you how you to manage them on your computer. Let’s start with the
            most frequently asked questions…
          </UitkText>
          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h2" size={3}>
              What is a cookie?
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            In short, a cookie is a small text file that is placed on your computer or mobile device to help ensure that
            you get the best possible experience when you visit a website.
          </UitkText>
          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h2" size={3}>
              Why does Expedia Group use cookies?
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            Cookies allow us to improve the website’s content, functionality and speed, while their tracking ability
            also helps us to understand your likes and dislikes, which means we can respond quickly and adapt the site
            accordingly.
          </UitkText>
          <UitkText spacing="six">
            At Expedia Group, we use cookies because it’s important to us that the time you spend on our website, is as
            useful and intuitive as possible.
          </UitkText>
          <UitkText spacing="six">
            In fact without cookie placement, a website cannot remember your preferences or registration details for
            your next visit.
          </UitkText>
          <UitkText spacing="six">
            The important thing to remember about all of this is that whilst some cookies are used to track your use of
            our website, they cannot be used to identify you personally or tell us who you are.
          </UitkText>
          <UitkText spacing="six">
            Here’s a snapshot of all of the cookies we use on affiliates.expedeiagroup.com along with a snippet of
            information about what they do.
          </UitkText>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h2" size={3}>
              What cookies does Expedia Group use?
            </UitkHeading>
          </UitkSpacing>
          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h3" size={5}>
              First and third-party cookies
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            There are many different types of cookies and at affiliates.expediagroup.com we use most of them. Those set
            by us are called ‘first-party cookies’. Those set by our partners and suppliers are called ‘third-party
            cookies’.
          </UitkText>
          <UitkText spacing="six">
            Third-party cookies enable visitors to our website to see and interact with content such as videos and
            advertising provided to us by other companies. The same cookies can also help us with website analytics.
            More on that a little later.
          </UitkText>
          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h3" size={5}>
              Session and persistent cookies
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            As with most websites, we also use ‘session cookies’, which exist only for the length of time that you visit
            our site and are deleted once you close your browser, along with ‘permanent cookies’ also known as
            ‘persistent cookies’ which remain stored on your browser ready for use the next time you visit our website.
          </UitkText>
          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h3" size={5}>
              Essential cookies
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            These are required to help you access secure areas (such as your partner account pages). Essential cookies
            are critical because you can’t access these services without them.
          </UitkText>
          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h3" size={5}>
              Performance and functionality cookies
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            These cookies ensure the display of handy features such as maps and videos. We love them because they help
            to enhance the performance and functionality of our website, and we want the time you spend on our site to
            be both useful and engaging.
          </UitkText>
          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h3" size={5}>
              Analytics and customisation cookies
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            We use analytics and customisation cookies to gather information on how the website is being used by our
            visitors and to discover how popular our marketing campaigns are. We also use the data we get to help
            customise the website for you and make the content you see as relevant as possible.
          </UitkText>
          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h3" size={5}>
              Advertising cookies
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            Advertising cookies are used to ensure that we only show you the adverts and messages we think you will want
            to see. Cleverly, they also help us to restrict the number of times you see the same advert, ensure the ad
            is properly displayed.
          </UitkText>
          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h3" size={5}>
              Social networking cookies
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            As the name suggests, Social Networking Cookies allow visitors like you to share our pages and content
            through third-party social networking websites. Why not put them to the test and share this page when you
            finish reading it?
          </UitkText>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h2" size={3}>
              How can you manage cookies?
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            We hope you’re now feeling confident about what cookies can do, and how we use them at Expedia Group to
            improve your website experience, but we know that you may want to manage your cookies from time to time so
            here are some tips!
          </UitkText>
          <UitkText spacing="six">
            You can set or amend your web browser controls to accept or refuse cookies whenever you like, but please
            remember if you do choose to reject cookies, your access to some of the functionality and areas of our
            website may be restricted.
          </UitkText>
          <UitkText spacing="six">
            Most advertising networks offer you a way to opt out of targeted and online behavioural advertising. If
            you’d like to find out more information on how to opt out visit{' '}
            <a href="https://www.youronlinechoices.com" target="_blank">
              Your Online Choices
            </a>{' '}
            website.
          </UitkText>
          <UitkText spacing="six">
            By opting in to cookie usage, you allow us to show you content, ads and emails that we think you’ll want to
            see; to collect data so we can improve your site experience; and to share information about your use of the
            site with third-party advertising and analytics partners. You may manage your cookie settings by clicking on
            the cookie icon that appears on your screen at any time.
          </UitkText>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h2" size={3}>
              Online Behavioral Advertising Cookies
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">
            Expedia Group adheres to the European Interactive Digital Advertising Alliance (“EDAA”) Principles. For more
            information about the EDAA, you can visit the{' '}
            <a href="http://www.edaa.eu/edaa-for-users/" target="_blank">
              EDAA website
            </a>
            . If you wish to make a query or complaint about our use of online behavioural advertising cookies, please
            use the details listed in the “How to contact us” section below.
          </UitkText>
          <UitkText spacing="six">
            For more information on what information is collected and how it is used, please see the{' '}
            <UitkLink inline={true}>
              <a href="privacy-policy">Privacy Policy</a>
            </UitkLink>
            .
          </UitkText>
          <UitkText spacing="six">
            Expedia Group does not process sensitive personal data for the online behavioural advertising purposes. We
            do not target anyone under the age of 16 on our website in general, nor for online behavioural advertising
            purposes.
          </UitkText>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <UitkHeading tag="h2" size={3}>
              How to contact us
            </UitkHeading>
          </UitkSpacing>
          <UitkText spacing="six">All notices should be sent to: {address}</UitkText>
          <UitkText spacing="six">
            Questions? Contact us at <a href={`mailto:${email}`}>{email}</a>.
          </UitkText>
        </main>
      </UitkSpacing>
    );
  }
}
